<template lang="pug">
  .chongqing-container-start
    router-view
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>
<style>
.chongqing-container-start{
  width: 100%;
  height: 100%;
  -webkit-overflow-scrolling: touch;
}
</style>